module.exports = __webpack_public_path__ + "static/media/introduksjon-Ordforstaelse.772b30ca.mp3";